class DossierPerfumeAssistant {
  constructor() {
    // Configuration || Settings
    this.apiBaseUrl = 'https://assistant.dossier.co';
    this.chatIndex = 0;
    this.email = this.getRandomEmail();
    this.chatStarted = false;
    // this.email = 'c@mail.com';
    this.productHandles = [];

    // Classes || IDs
    this.headerMobileHideClass = 'no-header--mobile';
    this.perfumeAssistantClass = 'perfume-assistant';
    this.perfumeAssistantFormClass = 'perfume-assistant__form';
    this.buttonToggleRecommendedClass = 'button__toggle-recommended';

    // Elements || Selectors
    this.perfumeAssistantHeader = document.querySelector('.perfume-assistant__header');
    this.dossierPerfumeAssistant = document.querySelector('dossier-perfume-assistant');
    // this.introStep = document.querySelector('.perfume-assistant__intro');
    // this.introForm = this.introStep.querySelector(`.${this.perfumeAssistantFormClass}`);
    // this.userEmail = 
    this.searchStep = document.querySelector('.perfume-assistant__search');
    this.searchForm = this.searchStep.querySelector(`.${this.perfumeAssistantFormClass}`);
    this.suggestionTextItems = this.searchStep.querySelectorAll('.perfume-assistant__suggestion');
    this.chatStep = document.querySelector('.perfume-assistant__chatAI');
    this.chatForm = this.chatStep.querySelector(`.${this.perfumeAssistantFormClass}`);
    this.chatbox = this.chatStep.querySelector('.perfume-assistant__chatbox');
    this.chatTemplate = document.getElementById('chat-template');
    this.productsContainer = document.querySelector('.perfume-assistant__products');
    this.perfumeSuggestions = document.querySelectorAll('.perfume-assistant__suggestions');
    this.suggestionsSlideshowContent = document.querySelector('.perfume-assistant__suggestions-content');
    this.suggestionsSlideshowNav = document.querySelector('.perfume-assistant__suggestions-nav');
    this.prevStepButton = document.querySelector('.step-action .button__prev-step');
    this.aiResults = document.querySelector('.perfume-assistant__ai-results');
    this.productsRecommended = document.querySelector('#products-recommended');
    // this.restartButton = document.querySelector('.perfume-assistant__suggestion-restart');

    // Ainee Popup
    this.aineePopup = document.getElementById('ainee-popup');

    //memory
    this.viewKey;
    this.productHandlesWithScentFamily = [];
  }

  init() {
    this.setPerfumeAssistantStep();
    // this.onEmailFormSubmit();
    this.onMessageFormSubmit();
    this.initSuggestionsSlideshow();
    this.updateContentOnScroll();
    this.navigateBack();
    this.handleSuggestionSelection();
    // this.updateProductsLocationByViewport();
    this.toggleRecommendedProducts();
    // this.restartButtonLogic();
    // this.initMobileUpdate();
    this.closeAineePopup();
  }

  setPerfumeAssistantStep() {
    // console.log('>>@>> din step init')
    document.body.dataset.perfumeAssistantStep = 1;
  }

  updatePerfumeAssistantStep(stepNumber) {
    const newStep = Math.max(1, Math.min(3, stepNumber));
    document.body.dataset.perfumeAssistantStep = newStep.toString();
  }

  // onEmailFormSubmit() {
  //   const validateEmail = (email) =>
  //     /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  //   const currentStep = this.introStep;
  //   const nextStep = this.searchStep;
  //   const form = this.introForm;
  //   const input = form.querySelector('#email');

  //   const handleEmailSubmit = async () => {
  //     const inputValue = input.value.trim();

  //     if (!validateEmail(inputValue)) {
  //       form.classList.add('error');
  //       return;
  //     }

  //     this.email = inputValue;

  //     try {
  //       const response = await fetch(`${this.apiBaseUrl}/users/ca/add/v2`, {
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify({ email: this.email }),
  //       });

  //       if (!response.ok) {
  //         console.error('Failed to submit email:', response.statusText);
  //         return;
  //       }

  //       input.value = '';
  //       form.classList.remove('error');
  //       this.updatePerfumeAssistantStep(2);
  //     } catch (error) {
  //       console.error('Error submitting email:', error);
  //     }
  //   };

  //   input.addEventListener('keydown', (event) => {
  //     if (event.key === 'Enter') {
  //       event.preventDefault();
  //       handleEmailSubmit();
  //     }
  //   });

  //   input.addEventListener('input', () => {
  //     form.classList.remove('error');
  //   });

  //   form.addEventListener('submit', (event) => {
  //     event.preventDefault();
  //     handleEmailSubmit();
  //   });
  // }

  onMessageFormSubmit() {
    const forms = [this.searchForm, this.chatForm];

    const handleSubmittedMessage = async (form) => {
      const input = form.querySelector('#query');
      const userMessage = input.value.replace(/(\S)/, (m) => m.toUpperCase());

      if (userMessage === '') {
        form.classList.add('error');
        return;
      }

      input.value = '';
      form.classList.remove('error');

      //start chat by user add
      if (this.chatStarted == false) {
        try {
          const response = await fetch(`${this.apiBaseUrl}/users/au/add/v2`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: this.email }),
          });

          if (!response.ok) {
            console.error('Failed to submit email:', response.statusText);
            return;
          }

          this.chatStarted = true;

          // input.value = '';
          // form.classList.remove('error');
          // this.updatePerfumeAssistantStep(2);
        } catch (error) {
          console.error('Error submitting email:', error);
        }
      }

      // Handle step transition if it's on the search step
      if (form === this.searchForm && this.searchStep && this.chatStep) {
        this.updatePerfumeAssistantStep(2);
      }

      // 👤 Render the user message
      this.renderChatTemplate(userMessage);

      if (form === this.chatForm && this.searchStep && this.chatStep) {
        window.scrollTo(0, document.body.scrollHeight);
      }

      try {
        const messageResponse = await fetch(`${this.apiBaseUrl}/conversations/au/add-message/v2`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email, message: userMessage }),
        });

        if (!messageResponse.ok) {
          console.error('Failed to submit message:', messageResponse.statusText);
          return;
        }

        const startResponse = await fetch(`${this.apiBaseUrl}/conversations/au/start/v3`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email: this.email }),
        });

        if (!startResponse.ok) {
          console.error(`Error starting conversation: ${startResponse.status} ${startResponse.statusText}`);
        } else {
          const data = await startResponse.json();
          let responseHTML = data.lastAssistantMessage;

          // 🔍 Extract the product title from original markdown-style **...** (before it's replaced)
          let productTitleMatch = responseHTML.match(/\*\*(.*?)\*\*/) || responseHTML.match(/"([^"]{3,})"/);
          // console.log('@>>>title match', productTitleMatch)
          let formattedHTML = responseHTML;
          if (responseHTML.includes('[**') || responseHTML.includes('](https')) { //new format 
            console.log('new format response')

            // Replace newlines with <br> tags
            formattedHTML = formattedHTML.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');

            // Escape problematic ampersands last
            formattedHTML = formattedHTML.replace(/&(?!(?:[a-z]+|#\d+);)/gi, '&amp;');

            formattedHTML = formattedHTML.replace(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/g, (match, linkText, url) => {
              try {
                const urlObj = new URL(url);
                const pathParts = urlObj.pathname.split('/').filter(Boolean);
                const rawHandle = pathParts.pop() || '';
                const finalLinkText = linkText.replaceAll('*', '');
                // console.log('final link text', finalLinkText)
                return `<span class="scent-highlight" data-scent-family>${finalLinkText}</span> — <a class="product-link" href="${urlObj.href}" target="_blank">${finalLinkText}</a>`;
              } catch {
                return match;
              }
            });
            formattedHTML = formattedHTML.replace(/\*\*.+?\*\*/g, '');
            formattedHTML = formattedHTML.replace(/\(<span.*?<\/a>\)/g, '');

          } else {
            // console.log('base format')
            // Wrap **...** with <span class="scent-highlight"></span>
            formattedHTML = responseHTML.replace(/"([^"]{3,})"/g, '<span class="scent-highlight" data-scent-family>$1</span>').replace(/\*\*(.*?)\*\*/g, '<span class="scent-highlight" data-scent-family>$1</span>');

            // Replace [text](url) or Replace plain URLs (with or without protocol)
            let firstLinkHandled = false;

            formattedHTML = formattedHTML.replace(/\[(.*?)\]\((https?:\/\/[^\s)]+)\)/g, (match, linkText, url) => {
              try {
                const urlObj = new URL(url);
                const pathParts = urlObj.pathname.split('/').filter(Boolean);
                const rawHandle = pathParts.pop() || '';
                if (!firstLinkHandled) {
                  this.productHandles.push(rawHandle);
                  firstLinkHandled = true;
                }
                // const finalLinkText = productTitle || linkText;
                const finalLinkText = linkText;
                // console.log('final link text', finalLinkText)
                return `<a class="product-link" href="${urlObj.href}" target="_blank">${finalLinkText}</a>`;
              } catch {
                return match;
              }
            });

            // function isInsideAnchorTag(string, index) {
            //   const lastOpen = string.lastIndexOf('<a ', index);
            //   if (lastOpen === -1) return false;
            //   const lastClose = string.lastIndexOf('</a>', index);
            //   return lastClose < lastOpen;
            // }

            // Replace newlines with <br> tags
            formattedHTML = formattedHTML.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');

            // Escape problematic ampersands last
            formattedHTML = formattedHTML.replace(/&(?!(?:[a-z]+|#\d+);)/gi, '&amp;');
          }


          const currentChatEl = this.chatbox.querySelector(`.perfume-assistant__chat[data-key="${this.chatIndex - 1}"]`);

          // console.log('product handles', this.productHandles)
          let productHandle = null;
          if (this.productHandles.length > 0) {
            productHandle = this.productHandles[this.productHandles.length - 1];
          }

          //take all handles in the response html
          let handlesList = [];


          const regexCheck = /https:\/\/[^"?]*\/([^"?/]+)(?=[?" ])/g;

          handlesList = [...formattedHTML.matchAll(regexCheck)].map(m => m[1]);

          handlesList = [...new Set(handlesList)] // keep handles unique in the list

          // console.log('handles list in response', handlesList)

          //END take all handles in the response html


          // 🤖 Render the AI response
          this.renderAiResponse(productHandle, currentChatEl, formattedHTML);

          // 🛍️ Render suggested product if available

          if (handlesList.length > 1) {
            let productsHandles = handlesList.join(',')
            // console.log('handlesd data', productsHandles)
            const productCard = this.productsContainer.querySelector(`.productCard[data-handle="${productsHandles}"]`);
            if (!productCard) {
              this.renderSuggestedProduct(currentChatEl, handlesList);
            }
          }
          else if (handlesList.length > 0) {
            const productCard = this.productsContainer.querySelector(`.productCard[data-handle="${handlesList[0]}"]`);
            if (!productCard) {
              this.renderSuggestedProduct(currentChatEl, handlesList);
            }
          }
        }
      } catch (error) {
        console.error('Error submitting message:', error);
      }
    };

    // Attach event listeners for both forms
    forms.forEach((form) => {
      const input = form.querySelector('#query');

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          handleSubmittedMessage(form);
        }
      });

      input.addEventListener('input', () => {
        form.classList.remove('error');
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        handleSubmittedMessage(form);
      });
    });
  }

  renderChatTemplate(userMessage) {
    const newChat = this.chatTemplate.content.cloneNode(true).firstElementChild;
    newChat.dataset.key = this.chatIndex++;
    this.toggleLoadingChatState(true);
    newChat.querySelector('.user-message').textContent = userMessage;
    this.chatbox.appendChild(newChat);
  }

  renderAiResponse(productHandle, chatElement, responseHTML) {
    if (productHandle) {
      chatElement.dataset.productHandle = productHandle;
    }

    let aiMassageWrapper = chatElement.querySelector('.ai-message-wrapper')
    aiMassageWrapper.querySelector('.loading-element').remove();
    const aiMessageEl = document.createElement('div');
    aiMessageEl.classList.add('ai-message');
    aiMassageWrapper.appendChild(aiMessageEl);

    //new way

    new Typed(aiMessageEl, {
      strings: [responseHTML],
      typeSpeed: 15,
      showCursor: false,
      contentType: 'html',
      onBegin: () => {
        const smoothScroll = () => {
          window.scrollTo({
            top: document.body.scrollHeight,
            behavior: 'auto'
          });
          if (this.isTyping) {
            requestAnimationFrame(smoothScroll);
          }
        };
        this.isTyping = true;
        requestAnimationFrame(smoothScroll);
      },
      onComplete: () => {
        this.isTyping = false;
        window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
        this.toggleLoadingChatState(false);
        this.updateScentHighlightInChat();
      }
    });
  }

  toggleLoadingChatState(isLoading) {
    this.dossierPerfumeAssistant.classList.toggle('loading', isLoading);
    document.body.classList.toggle('loading-ai-message', isLoading);
    this.chatForm.querySelector('#query').readOnly = isLoading;
    this.chatForm.querySelector('button').disabled = isLoading;
  }

  renderSuggestedProduct(chatElement, productHandles) {
    // Fetch product details using the Storefront API
    let STOREFRONT_TOKEN = '4647a7eacde8f68795722e2449af688c';

    productHandles = productHandles.map(str => str.replaceAll('-1', '').replaceAll('-v2', ''));

    // console.log('product handles', productHandles)

    let queryString = productHandles.map(h => `title:${h}`).join(' OR ');

    // remove specific handle text error
    queryString = queryString.replaceAll('-1', '').replaceAll('-v2', '')
    // console.log('query sttring', queryString)

    let query_aux = `
      query getByHandles($filter: String!) {
        products(first: 10, query: $filter ) {
          edges {
            node {
              id
              publishedAt
              availableForSale
              title
              handle
              tags
              productType
              vendor
              totalInventory
              priceRange {
                maxVariantPrice {
                  amount
                  currencyCode
                }
              }
              media(first: 1) {
                edges {
                  node {
                    ... on MediaImage {
                      image {
                        url
                        altText
                      }
                    }
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    title
                    availableForSale
                    price {
                      amount
                      currencyCode
                    }
                  }
                }
              }
              metafield(namespace: "custom", key: "scent_family") {
                value
                type
              }
            }
          }
        }
      }`

    fetch('/api/2025-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
      },
      body: JSON.stringify({
        query: query_aux,
        variables: {
          filter: queryString
        }
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`Network response was not ok: ${response.status}`);
        }
        return response.json();
      })
      .then(({ data }) => {

        // console.log('data response:', data)

        this.viewKey = this.chatIndex - 1;
        const currentChatEl = this.chatbox.querySelector(`.perfume-assistant__chat[data-key="${this.chatIndex - 1}"]`);

        //helper functions

        function parseProductData(product) {
          const variant = product.variants?.edges?.[0]?.node || {};
          const variantId = variant.id.split('/').pop() || '';
          const media = product.media?.edges?.[0]?.node?.image || {};
          const maxPrice = product.priceRange?.maxVariantPrice?.amount;

          return {
            id: product.id || '',
            variantId: variantId || '',
            title: product.title || '',
            handle: product.handle || '',
            url: `/products/${product.handle || ''}`,
            type: product.productType || '',
            vendor: product.vendor || '',
            price: parseFloat(maxPrice || '0').toString(),
            imageUrl: media.url || '',
            imageAlt: media.altText || '',
            scentFamily: product.metafield?.value || '',
            availableForSale: product.availableForSale ?? false,
            variantAvailable: variant.availableForSale ?? false
          };
        }

        // Format Product Vendor
        function formatVendorText(text) {
          // const disclaimerButton = `<ds-button><button class="button__disclaimer text-color--coral" type="button" data-modal-target="#product-disclaimer-modal" aria-label="disclaimer-button"><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none"><path d="M5.47113 9.87597C5.16718 9.87597 4.91389 9.81518 4.71125 9.69359C4.50862 9.55175 4.42756 9.36938 4.46809 9.14648L4.95441 5.98539L4.86323 5.9246L2.34044 7.96107C2.23912 8.02186 2.1378 8.05226 2.03648 8.05226C1.71227 8.05226 1.43871 7.83949 1.21582 7.41396C1.05371 7.13027 0.972656 6.88711 0.972656 6.68448C0.972656 6.44132 1.0841 6.26908 1.307 6.16776L4.31612 4.98235V4.89117L1.3374 3.70576C1.09424 3.60444 0.972656 3.4322 0.972656 3.18904C0.972656 2.96615 1.05371 2.72299 1.21582 2.45956C1.31713 2.25693 1.43871 2.09482 1.58056 1.97324C1.7224 1.85166 1.86425 1.79087 2.00609 1.79087C2.10741 1.79087 2.21886 1.8314 2.34044 1.91245L4.89362 3.94892L4.95441 3.88813L4.46809 0.696646C4.44783 0.473749 4.52888 0.30151 4.71125 0.17993C4.91389 0.0583492 5.16718 -0.00244141 5.47113 -0.00244141C5.81561 -0.00244141 6.07903 0.0583492 6.2614 0.17993C6.46404 0.30151 6.54509 0.473749 6.50456 0.696646L6.04864 3.91853L6.10943 3.97932L8.66262 1.91245C8.78419 1.8314 8.88551 1.79087 8.96657 1.79087C9.10841 1.79087 9.25025 1.85166 9.3921 1.97324C9.53394 2.09482 9.65552 2.25693 9.75684 2.45956C9.91895 2.72299 10 2.96615 10 3.18904C10 3.45247 9.88855 3.62471 9.66565 3.70576L6.62614 4.92157V4.98235L9.66565 6.16776C9.88855 6.24882 10 6.41092 10 6.65409C10 6.87698 9.91895 7.13027 9.75684 7.41396C9.51368 7.83949 9.25025 8.05226 8.96657 8.05226C8.84499 8.05226 8.74367 8.01173 8.66262 7.93068L6.10943 5.9246L6.04864 5.955L6.50456 9.14648C6.54509 9.36938 6.46404 9.55175 6.2614 9.69359C6.07903 9.81518 5.81561 9.87597 5.47113 9.87597Z" fill="#EF776A"/></svg><span class="sr-only">Disclaimer Button</span></button></ds-button>`;

          const regex = new RegExp(`^${inspiredByText}\\s*`, 'i');
          const cleanedText = text.replace(regex, '').trim();

          const parts = cleanedText.split(" de");
          let formattedVendor = '';

          if (parts.length >= 3) {
            formattedVendor = `${parts[0]} de ${parts[1]} de <strong>${parts[2]}</strong>`;
          } else if (parts.length === 2) {
            formattedVendor = `${parts[0]} de <strong>${parts[1]}</strong>`;
          } else {
            formattedVendor = `<strong>${cleanedText}</strong>`;
          }

          return `${inspiredByText}<br>${formattedVendor}`;
        }

        // Format Product Title
        function formatTitleText(text) {
          const parts = text.split(' ');
          if (parts.length > 1) {
            return parts[0] + ' <br> ' + parts.slice(1).join(' ');
          }
          return text;
        }

        //END helper functions

        if (data.products.edges.length > 0) {
          let products = data.products.edges

          // create slider for it

          let sliderEl = `
          <div class='carousel__recomended-products-wrapper ${products.length == 1 ? 'just-one' : ''}' data-key="${this.chatIndex - 1}">
            <div class="blaze-slider carousel__recomended-products" >
              <div class="blaze-container">
                <div class="blaze-track-container">
                  <div class="blaze-track">
                  </div>
                </div>
                <div class='nav_arrow_wrapper'>
                  <button class="blaze-prev"><img src="https://cdn.shopify.com/s/files/1/0625/4631/3452/files/arrow_black_left_v2.svg?v=1770300274" loading="lazy"></button>
                  <button class="blaze-next"><img src="https://cdn.shopify.com/s/files/1/0625/4631/3452/files/arrow_black_left_v2.svg?v=1770300274" loading="lazy"></button>
                </div>
                <div class="pagination-wrapper">
                  <div class="blaze-pagination"></div>
                </div>
              </div>
            </div>
          </div>

          `


          if (window.innerWidth < 768) {
            const aiRecomandedProductsWrapper = document.createElement('div');
            aiRecomandedProductsWrapper.classList.add('products-recommended', 'mobile-v', 'desktop-hidden');
            currentChatEl.appendChild(aiRecomandedProductsWrapper);

            currentChatEl.querySelector('.products-recommended.mobile-v').insertAdjacentHTML('beforeend', sliderEl);
          } else {

            this.productsContainer.insertAdjacentHTML('beforeend', sliderEl);
          }
          // END create slider for it

          // sort product based on the AI response product order
          const sortedProducts = productHandles.map(t => {
            return products.find(item => item.node.handle === t);
          }).filter(item => item !== undefined);


          sortedProducts.forEach((element, index) => {
            let product = element.node;

            //create product card
            const productData = parseProductData(product);
            const formattedTitle = formatTitleText(productData.title);
            const formattedVendor = formatVendorText(productData.vendor);

            let productActionHTML = `
            <product-form>
                <form method="post" action="/cart/add" id="quick-add-template--product-grid" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                  <input type="hidden" name="form_type" value="product">
                  <input type="hidden" name="utf8" value="✓">
                  <input type="hidden" name="id" value="${productData.variantId}">
                  <input type="hidden" name="properties[_ainee]" value="true">
                  <button type="submit" name="add" class="quick-add__submit button button--full-width button--primary" aria-haspopup="dialog" aria-live="polite" data-sold-out-message="true">
                    <span>${productAddToCartText}</span>
                    <div class="loading-overlay__spinner hidden">
                      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                      </svg>
                    </div>
                  </button>
                  <input type="hidden" name="product-id" value="${productData.variantId}">
                  <input type="hidden" name="section-id" value="product-grid">
                </form>
              </product-form>
              `;

            if (!productData.availableForSale || !productData.variantAvailable) {
              productActionHTML = `<product-form><ds-button><button class="quick-add__submit button button--full-width button--primary js-back-in-stock" data-modal-target="#back-in-stock-modal" data-variant-id="${productData.variantId}" data-product-title="${productData.title}" data-product-vendor="${productData.vendor}"><span>${productNotifyMeText}</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></ds-button></product-form>`;
            }

            // const btnCloseRecommendedHTML = '<button class="button button__toggle-recommended js-recommended" data-target="#product-recommended"><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none"><path d="M18.5034 7.14788L11.5067 15.0437L4.51003 7.14788" stroke-width="1.83376" stroke-linecap="round"/></svg></button>';

            let productCardHtml = `
            <div id="productCard__${productData.handle}" class="productCard active" data-id="${productData.id}" data-variant-id="${productData.variantId}" data-handle="${productData.handle}" data-title="${productData.title}" data-type="${productData.type}" data-scent-family="${productData.scentFamily}" data-index=${index}>
              <div class="productCard__container">
                <div class="productCard__image">
                  <a href="${productData.url}" class="productCard__image-link" target="_blank">
                    <img src="${productData.imageUrl}" alt="${productData.imageAlt}" class="productCard__image-img" width="326" height="326">
                  </a>
                </div>
                <div class="productCard__content">
                  <a href="${productData.url}" class="productCard__link" target="_blank">
                    <h3 class="productCard__title">${formattedTitle}</h3>
                    <div class="productCard__price">
                      <span class="price">${productCurrency}${productData.price}</span>
                    </div>
                    <div class="productCard__vendor">${formattedVendor}</div>
                  </a>
                  <div class="productCard__actions">${productActionHTML}</div>
                </div>
              </div>
            </div>
            `;
            //END create product card

            // add elements to slider

            if (window.innerWidth < 768) {
              currentChatEl.querySelector('.products-recommended.mobile-v').querySelector(`.carousel__recomended-products-wrapper[data-key='${this.chatIndex - 1}'] .blaze-track`).insertAdjacentHTML('beforeend', productCardHtml);
            } else {
              this.productsContainer.querySelector(`.carousel__recomended-products-wrapper[data-key='${this.chatIndex - 1}'] .blaze-track`).insertAdjacentHTML('beforeend', productCardHtml);
            }
          })

          //init slider

          let productCarouselEL = this.productsContainer.querySelector(`.carousel__recomended-products-wrapper[data-key='${this.chatIndex - 1}'] .carousel__recomended-products`);
          if (window.innerWidth < 768) {
            productCarouselEL = currentChatEl.querySelector('.products-recommended.mobile-v').querySelector(`.carousel__recomended-products-wrapper[data-key='${this.chatIndex - 1}'] .carousel__recomended-products`);
          }

          this.updateScentFamilyBodyClass();
          productCarouselEL.querySelector(`.productCard`).classList.add('currentActive')

          if (productCarouselEL && sortedProducts.length > 1) {
            const options = {
              all: {
                slidesToShow: 1,
                slidesToScroll: 1,
                loop: false,
                // transitionDuration: 250,
                draggable: false,
                slideGap: '1.6rem',
              },
              '(max-width: 768px)': {
                slidesToShow: 1,
                slidesToScroll: 1,
                slideGap: '.8rem',
                draggable: true,
                loop: false,
              },
            }

            let productCarousel = new BlazeSlider(productCarouselEL, options);
            let cards = productCarouselEL.querySelectorAll(`.productCard`);
            cards[0].classList.add('currentActive'); //make first card in slider the current active
            const unsubscribe = productCarousel.onSlide(
              (pageIndex) => {
                // console.log('Visible slides:', firstSlideIndex, 'to', lastSlideIndex);
                cards.forEach(card => {
                  if (card.dataset.index == pageIndex) {
                    card.classList.add('currentActive')
                  }
                  else {
                    card.classList.remove('currentActive')
                  }
                })
                this.updateScentFamilyBodyClass();// update scent family effect on slide change
              }
            );
          }
          // END init slider

          // add scent family to the chat product titles
          let scentsFamily = products.map(product => ({ name: product.node.title, scentFamily: product.node?.metafield?.value || '' }))
          this.productHandlesWithScentFamily = [...scentsFamily]
          // END add scent family to the chat product titles

        } else {
          console.error('Products not found');
          return;
        }


        this.updateCurrentRecomandations();
        this.updateScentFamilyBodyClass();

      })
      .catch(error => {
        console.error('Fetch error:', error);
      });
  }

  removeScentFamilyBodyClass() {
    this.dossierPerfumeAssistant.classList.forEach(className => {
      if (className.startsWith("scent-family__")) {
        this.dossierPerfumeAssistant.classList.remove(className);
      }
    });
  }

  updateScentFamilyBodyClass() {
    let currentActiveElement = this.dossierPerfumeAssistant.querySelector('.perfume-assistant__ai-results .carousel__recomended-products-wrapper.active .productCard.currentActive');

    if (window.innerWidth < 768) {
      currentActiveElement = this.dossierPerfumeAssistant.querySelector(`.perfume-assistant__chat .products-recommended.mobile-v .carousel__recomended-products-wrapper.active .productCard.currentActive`)
    }

    if (currentActiveElement) {
      let scentFamily = currentActiveElement.dataset?.scentFamily.toLowerCase();
      if (scentFamily) {
        this.dossierPerfumeAssistant.classList.forEach(className => {
          if (className.startsWith('scent-family__')) {
            this.dossierPerfumeAssistant.classList.remove(className);
          }
        });

        this.dossierPerfumeAssistant.classList.add(`scent-family__${scentFamily}`);
      }
    }
  }

  updateCurrentRecomandations(specificKey) {
    //changes what products recomandation slider is shown based on chat in focus

    let key;
    if (specificKey != undefined) {
      key = specificKey
    } else {
      key = this.viewKey
    }

    let recomandationsList = this.dossierPerfumeAssistant.querySelectorAll(`.perfume-assistant__products .carousel__recomended-products-wrapper`)
    if (window.innerWidth < 768) {
      recomandationsList = this.dossierPerfumeAssistant.querySelectorAll('.perfume-assistant__chatbox .products-recommended.mobile-v .carousel__recomended-products-wrapper')
    }
    recomandationsList.forEach(element => {
      if (element.dataset.key == key) {
        element.classList.add('active');
      } else {
        element.classList.remove('active');
      }
    })

    this.updateScentFamilyBodyClass();
  }

  initSuggestionsSlideshow() {
    if (!this.suggestionsSlideshowContent || !this.suggestionsSlideshowNav) return;

    const scrollContainer = this.suggestionsSlideshowContent;
    const scrollButton = this.suggestionsSlideshowNav.querySelector('.slider-next');

    if (!scrollButton) return;

    scrollButton.addEventListener('click', () => {
      const scrollAmount = scrollContainer.clientWidth;
      const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      const currentScrollLeft = scrollContainer.scrollLeft;

      if (currentScrollLeft >= maxScrollLeft - 1) {
        scrollContainer.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        const targetScrollLeft = Math.min(currentScrollLeft + scrollAmount, maxScrollLeft);
        scrollContainer.scrollTo({ left: targetScrollLeft, behavior: 'smooth' });
      }
    });
  }

  updateContentOnScroll() {
    window.addEventListener('scroll', () => {

      if (document.body.classList.contains('loading-ai-message')) {
        return
      }

      const triggerLine = window.innerHeight - (window.innerHeight * 0.45);
      let listItems = document.querySelectorAll('.perfume-assistant__chat');
      let closestElement = null;
      let minDistance = Infinity;

      listItems.forEach(item => {
        const rect = item.getBoundingClientRect();

        const itemMidpoint = rect.top + (rect.height / 2);
        const distance = Math.abs(triggerLine - itemMidpoint);

        if (distance < minDistance) {
          minDistance = distance;
          closestElement = item;
        }
      });

      if (closestElement) {
        let elementKey = closestElement.dataset.key;
        this.updateCurrentRecomandations(elementKey);
      }
    });
  }

  navigateBack() {
    if (!this.prevStepButton) return;
    this.prevStepButton.addEventListener('click', (event) => {
      event.preventDefault();
      history.back();
    });
  }

  handleSuggestionSelection() {
    this.perfumeSuggestions.forEach(suggestionsContainer => {
      const suggestions = suggestionsContainer.querySelectorAll('.perfume-assistant__suggestion');

      suggestions.forEach(suggestion => {
        // Do something with each suggestion inside this container
        suggestion.addEventListener('click', (e) => {
          if (e.target.closest('.perfume-assistant__suggestion-restart')) {

            //restart conversation
            console.log('s-a dat click restart')

            document.body.dataset.perfumeAssistantStep = 1;
            if (this.aiResults.querySelector('.perfume-assistant__products')) {

              this.aiResults.querySelector('.perfume-assistant__products').innerHTML = ``;
            }
            this.aiResults.querySelector('.perfume-assistant__chatbox').innerHTML = ``;
            this.dossierPerfumeAssistant.classList.forEach(className => {
              if (className.startsWith('scent-family__')) {
                this.dossierPerfumeAssistant.classList.remove(className);
              }
            });

            //remove loading classes
            this.dossierPerfumeAssistant.classList.remove('loading');
            document.body.classList.remove('loading-ai-message');
            document.querySelector('#chat__form').classList.remove('error');

            return;
          }

          const suggestionText = suggestion.textContent.trim();
          const stepForm = suggestion.closest(`.${this.perfumeAssistantClass}`).querySelector(`.${this.perfumeAssistantFormClass}`);
          if (!stepForm) return;
          const input = stepForm.querySelector('input[type="text"]');
          if (!input) return;
          input.value = suggestionText.replace(/(\S)/, (m) => m.toUpperCase());
          stepForm.dispatchEvent(new Event('submit', { bubbles: true }));

          const currentStep = parseInt(document.body.dataset.perfumeAssistantStep) || 1;
          if (currentStep === 2) {
            window.scrollTo(0, document.body.scrollHeight);
          }
        });
      });
    });
  }

  // updateProductsLocationByViewport() {
  //   console.log('din move to mobiel product recomandation')
  //   const moveProductsContainer = () => {
  //     if (!this.productsContainer || !this.aiResults || !this.productsRecommended) return;

  //     const currentParent = this.productsContainer.parentElement;

  //     if (window.innerWidth <= 900 && currentParent !== this.productsRecommended) {
  //       this.productsRecommended.prepend(this.productsContainer);
  //     } else if (window.innerWidth > 900 && currentParent !== this.aiResults) {
  //       this.aiResults.prepend(this.productsContainer);
  //     }
  //   };

  //   moveProductsContainer();
  //   window.addEventListener('resize', moveProductsContainer);
  // }

  toggleRecommendedProducts() {
    document.addEventListener('click', (e) => {
      const recommendedBtn = e.target.closest(`.${this.buttonToggleRecommendedClass}`);
      if (recommendedBtn && this.chatStep) {
        this.productsRecommended.classList.toggle('active');
        this.chatStep.classList.toggle('show-recommended');
      }
    });
  }

  getRandomEmail() {
    const sessionKey = 'userAISession';
    const existingSession = localStorage.getItem(sessionKey);

    if (existingSession) {
      // console.log("Session found:", existingSession);
      return existingSession;
    } else {
      // generate new random email and session
      let now = +new Date(); //time-stamp
      const randomThreeCharacters = Math.random().toString(36).substring(2, 5);

      const defaultValue = `dsr-${now}-${randomThreeCharacters}@trydossier.co`;
      console.log('value', defaultValue)
      localStorage.setItem(sessionKey, defaultValue);

      return defaultValue;
    }
  }

  updateScentHighlightInChat() {
    // console.log('chat index', this.chatIndex)
    let currentChat = this.dossierPerfumeAssistant.querySelector(`.perfume-assistant__chat[data-key='${this.chatIndex - 1}']`);
    // console.log('current chat', currentChat)
    let scentHighlightsEls = currentChat.querySelectorAll('.scent-highlight');

    if (this.productHandlesWithScentFamily.length > 0) {

      this.productHandlesWithScentFamily.forEach(el => {
        scentHighlightsEls.forEach(subEl => {
          if (subEl.innerText == el.name) {
            subEl.dataset.scentFamily = el.scentFamily.toLowerCase();
          }
        })
      })
    }
  }

  closeAineePopup() {
    this.aineePopup.addEventListener('click', (event) => {
      const modalContent = this.aineePopup.querySelector('.ds-modal__content');
      const insideContent = modalContent.contains(event.target);
      const showPopup = this.aineePopup.classList.contains('show');

      if (showPopup && !insideContent) {
        this.aineePopup.classList.remove('show');
      }
    });
  }
}

const dossierPerfumeAssistant = new DossierPerfumeAssistant();
dossierPerfumeAssistant.init();